module.exports = __webpack_public_path__ + "media/photo/dev-03febeff.jpg";